import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// Create axios instance
const user = JSON.parse(localStorage.getItem('user'));
//console.log(user)
const token = user?.token;
//console.log("Sending token:", token);
// ✅ Axios for login/public APIs
export const axiosPublic = axios.create({
   //baseURL: 'http://localhost/Encryption',
  baseURL: 'https://kosmicwipe.com/apis',
});

export const axiosPrivate = axios.create({
  //baseURL: 'http://localhost/Encryption',
  baseURL: 'https://kosmicwipe.com/apis',
});

// Request interceptor
axiosPrivate.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const token = user?.token;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    } else {
      localStorage.removeItem('user');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosPrivate.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('user');

      // Optional: force reload to reset app state (especially if hooks are not available)
      window.location.href = '/login'; 
    }

    return Promise.reject(error);
  }
);

export const login = (username, password) => {
  return axiosPublic.post('/users/login.php', { username, password });
};

export const getAllUsers = async () => {
  //console.log(token)
  return await axiosPrivate.get('/users/getAll_users.php');
};

export const getUser = async () => {
  return await axiosPrivate.get('/users/get_user.php');
};

export const getCompanyDepartment = (id) => {
  //console.log('i am company',id)
  return axiosPrivate.post('/department/company_department.php',id);
};

export const getCompanyUsers = async(id) => {
  const res = await axiosPrivate.post('/users/get_companyUsers.php', id)
  //console.log(res)
  return await axiosPrivate.post('/users/get_companyUsers.php', id);
};

export const editUser = (data) => {
  return axiosPrivate.post('/users/edit_user.php', data);
};

export const deleteUser = (data) => {
  return axiosPrivate.post('/users/delete_user.php', data);
};

export const deleteMultipleUser = (data) => {
  return axiosPrivate.post('/users/deleteMultiple_users.php', data);
};

export const addUserDepartment = (data) => {
  return axiosPrivate.post('/users/add_userDepartment.php', data);
};

export const editUserDepartment = (data) => {
  //console.log(data)
  return axiosPrivate.post('/users/edit_userDepartment.php', data);
};

export const getCompanyDevices = (data) => {
  return axiosPrivate.post('/devices/get_companyDevices.php', data);
};

export const getCompanies = () => {
  return axiosPrivate.get('/company/getall_company.php');
};

export const addDevices = (data) => {
  return axiosPrivate.post('/devices/add_devices.php', data);
};

export const getAllDevices = () => {
  return axiosPrivate.get('/devices/getAll_devices.php');
};

export const addCompany = (data) => {
  return axiosPrivate.post('/company/add_company.php', data);
};

export const deleteCompany = (data) => {
  return axiosPrivate.post('/company/add_company.php', data);
};

export const editCompany = (data) => {
  return axiosPrivate.post('/company/edit_company.php', data);
};

export const addDepartment = (data) => {
  return axiosPrivate.post('/department/add_department.php', data);
};

export const deleteDepartment = (data) => {
  return axiosPrivate.post('/department/delete_department.php', data);
};

export const editDepartment = (data) => {
  return axiosPrivate.post('/department/edit_department.php', data);
};

export const deleteAllDepartment = (data) => {
  return axiosPrivate.post('/department/deleteMultiple_departments.php', data);
};

export const getAllDepartments = () => {
  return axiosPrivate.get('/department/getAll_department.php');
};

export const editLastLogin = (data) => {
  return axiosPrivate.post('/devices/edit_lastLogin.php', data);
};

export const editDiskCount = (data) => {
  return axiosPrivate.post('/devices/edit_diskCount.php', data);
};

export const getDashboard = (id) => {
  return axiosPrivate.get('/dashboard/get_dashboardData.php', id);
};

export const getCompanyDashboard = (id) => {
  return axiosPrivate.post('/dashboard/get_companyDashboard.php', id);
};

export const getDevicesCards = (id) => {
  return axiosPrivate.post('/dashboard/getDevicesCards.php', id);
};
export const getLiveAgents =(data)=>{
  return axiosPrivate.post('/devices/getActiveAgents.php',data)
}
export const getLogs = (data) => {
  //console.log(data);
  return axiosPrivate.post('/logs/getAll_logs.php', data);
};

export const getCompanyLogs = (data) => {
  //console.log(data);
  return axiosPrivate.post('/logs/company_logs.php', data);
};

export const getUserLogs = (data) => {
  //console.log(data);
  return axiosPrivate.post('/logs/user_logs.php', data);
};

export const addOperation = (data) => {
  return axiosPrivate.post('/operations/addOperations.php', data);
};

export const getOperations = () => {
  return axiosPrivate.get('/operations/cron.php');
};

export const addQueueOperation = (data) => {
  //console.log(data);
  return axiosPrivate.post('/operations/addQueued.php', data);
};

export const restartOperation = (data) => {
  //console.log(data);
  return axiosPrivate.post('/operations/restartOperation.php', data);
};

export const cancelOperation = (data) => {
  //console.log(data);
  return axiosPrivate.post('/operations/cancelOperation.php', data);
};

export const editUsbStatus=(data)=>{
  return axiosPrivate.post('/devices/edit_usbStatus.php', data);
}
export const getSYSAuth = (data) => {
  //console.log(data);
  return axiosPrivate.post('/sysAuth.php', data);
};

export const requestOperation = (data) => {
  return axiosPrivate.post('/operations/requestOperation.php', data);
};
export const resendOtp = (data) => {
  return axiosPrivate.post('/operations/resendOtp.php', data);
};
export const verifyOtp=(data)=>{
  return axiosPrivate.post('/operations/verifyOtp.php', data);
}
export const getLicences = (data) => {  
  return axiosPrivate.post('/license/getAll_license.php',data);
};
export const addLicence = (data) => {
  return axiosPrivate.post('/license/addLicence.php', data);
};
export const attachLicence = (data) => {
  return axiosPrivate.post('/license/attachLicence.php', data);
};
export const deleteLicence = (data) => {  
  return axiosPrivate.post('/license/deleteLicence.php', data); 
};
 export const notLicenced = (data) => {
  return axiosPrivate.post('/license/notLicencedDevices.php', data);
};
export const dashLicenceData=(data)=>{
  return axiosPrivate.post('/dashboard/get_licencesData.php', data);
}
  export const getDevice=(data)=>{
      return axiosPrivate.post('/devices/get_devices.php', data);
  }

  export const checkDiskChange=(uuid)=>{
    return axiosPrivate.post('/devices/check_serial.php',{uuid})
  }
  export const diskChangedLogs=(data)=>{
    return axiosPrivate.post('/logs/disk_changedLogs.php',data)
  }
  export const checkValid=(data)=>{
    return axiosPrivate.post('/license/checkValid.php',data)
  }
export default axiosPrivate;